import { render, staticRenderFns } from "./StepHeaderListComponent.vue?vue&type=template&id=4b91b2ad"
import script from "./StepHeaderListComponent.vue?vue&type=script&lang=ts"
export * from "./StepHeaderListComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports